import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Loader from "../../../components/elements/Loader";
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import Title from "../../elements/Title";
import {setStore} from "trim-redux";

class EditCode extends React.Component {
    state = {
        fields:{
            name:"",
            code:"",
        },
        errors:{},
        loading: true,
        SubmitLoading: false,
        id:null,
    };
    classes = this.props.classes;
    id = this.props.table;
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');

        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/code/get/${this.id}`, config)
                .then(response => {
                    let data = response.data;
                    this.setState({
                        fields: {
                            name: data.name,
                            code: data.html,
                        },
                        loading:false
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }
    handleRequest(){
        let {fields} = this.state;
        let data = new FormData();
        data.append('id', this.id);
        data.append('name', fields.name);
        data.append('html', fields.code);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/code/edit`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.codeEdited, {
                    variant: 'success',
                });
                this.props.setTable(response.data)
            })
            .catch(error => {

                this.props.enqueueSnackbar(Translate.codeEditingFailed, {
                    variant: 'error',
                });
            });
        this.setState({
            loading:false,
            SubmitLoading:false,
        });

    }
    handleValidation(callback){
        let { fields,data } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(!fields.name){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(!fields.code){
            formIsValid = false;
            errors['code'] = Translate.emptyField;
        }
        this.setState({errors},() =>{
            if(!formIsValid){
                this.setState({
                    SubmitLoading:false
                })
            }
            return callback(formIsValid)
        });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.setState({
                    loading:true
                });
                this.handleRequest();
            }
        });
    }
    setData(data,heading){
        this.setState({
            data,
            heading
        })
    }
    handleBuild(){
        this.setState({
            build:true
        })
    }
    render(){
        let {fields,SubmitLoading,errors} = this.state;
        return (
            <React.Fragment>
                {
                    this.state.loading ? <Loader/> :
                        <Grid container spacing={2} direction="row" alignItems="center" justify="center">
                            <Grid item md={10} lg={8}>
                                <Title>{Translate.EditCode}</Title>
                            </Grid>
                            <Grid item md={10} lg={8}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="name"
                                    label={Translate.codeName}
                                    type="text"
                                    id="name"
                                    value={fields.name}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['name']}
                                    helperText={errors['name']}
                                />
                            </Grid>
                            <Grid item md={10} lg={8}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="code"
                                    multiline
                                    minRows={8}
                                    label={Translate.htmlCode}
                                    type="text"
                                    value={fields.code}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['code']}
                                    helperText={errors['code']}
                                />
                            </Grid>
                            <Grid item  md={10} lg={8}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.EditCode}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                }
            </React.Fragment>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(EditCode)));